export default __webpack_public_path__ + "static/media/avatar.16759714.png";